// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

a {
  color: var(--ion-color-secondary);
}

.subscription-control {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.subscription-control--toggle {
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.subscription-copy {
  margin: 0;
  flex: 1;
  text-align: left;
}

ion-checkbox {
  flex-shrink: 0;
  margin-top: 2px;
}

ion-toggle {
  flex-shrink: 0;
  padding-top: 2px;
  --handle-background: var(--ion-color-primary);
  --handle-background-checked: #fff;
  --track-background: #d8d8d8;
  --track-background-checked: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/subscribe-to-mailing-checkbox/subscribe-to-mailing-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;EACA,WAAA;AACD;;AAEA;EACC,iCAAA;AACD;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AACD;;AAEA;EACC,uBAAA;EACA,8BAAA;EACA,SAAA;AACD;;AAEA;EACC,SAAA;EACA,OAAA;EACA,gBAAA;AACD;;AAEA;EACC,cAAA;EACA,eAAA;AACD;;AAEA;EACC,cAAA;EACA,gBAAA;EACA,6CAAA;EACA,iCAAA;EACA,2BAAA;EACA,oDAAA;AACD","sourcesContent":[":host {\n\tdisplay: block;\n\twidth: 100%;\n}\n\na {\n\tcolor: var(--ion-color-secondary);\n}\n\n.subscription-control {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 12px;\n\twidth: 100%;\n}\n\n.subscription-control--toggle {\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\tgap: 16px;\n}\n\n.subscription-copy {\n\tmargin: 0;\n\tflex: 1;\n\ttext-align: left;\n}\n\nion-checkbox {\n\tflex-shrink: 0;\n\tmargin-top: 2px;\n}\n\nion-toggle {\n\tflex-shrink: 0;\n\tpadding-top: 2px;\n\t--handle-background: var(--ion-color-primary);\n\t--handle-background-checked: #fff;\n\t--track-background: #d8d8d8;\n\t--track-background-checked: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
